// types
import { FeatureConfig } from "../types/featureFlags";

/**
 * Global state manager for Public API configuration
 */

let enablePublicApiGlobal = true;

export const PublicApiGlobalState = {
    setEnablePublicApi: (enabled: boolean): void => {
        enablePublicApiGlobal = enabled;
        // global Header state is not available in the core-utils, hence we are using this global state with a fallback as a good practice,
    },
    getEnablePublicApi: (): boolean => {
        return enablePublicApiGlobal;
    },
} as const;

/**
 * Determines if the public API is enabled based on platform and feature configuration
 * @param config - The feature configuration object containing feature flags
 * @param configKey - The key for the feature section within the config
 * @param featureKey - The specific feature key to check within the section
 * @returns boolean indicating if the public API is enabled
 */

export const isPublicApiEnabled = (_config: FeatureConfig, _configKey: string, _featureKey: string) => {
    return PublicApiGlobalState.getEnablePublicApi();
};
